import React, {Component} from 'react'
import AppBarView from "../components/AppBarView";
import {withAuth0} from "@auth0/auth0-react";
import {connect} from "react-redux";

class AppBarContainer extends Component{
    render() {
        const {authedUser, notification_size} = this.props
        return(
            <AppBarView
                profile={authedUser}
                notification={notification_size}
            />
        )
    }
}

function mapStateToProps({authedUser, notification}){
    return{
        authedUser,
        notification_size: Object.values(notification).reduce((n, e)=>e.seen===false?n+1:n,0)
    }
}

export default connect(mapStateToProps)(withAuth0(AppBarContainer))